export interface DocumentScopeQuery {
  inspectionId?: string;
  templateId?: string;
  issueId?: string;
}

export function normalizeDocumentScopeQuery(
  query: DocumentScopeQuery | undefined
): DocumentScopeQuery | undefined {
  if (!query) {
    return undefined;
  }

  const { inspectionId, templateId, issueId } = query;
  const normalized: DocumentScopeQuery = {};

  if (inspectionId) normalized.inspectionId = inspectionId;
  if (templateId) normalized.templateId = templateId;
  if (issueId) normalized.issueId = issueId;

  return Object.keys(normalized).length > 0 ? normalized : undefined;
}

export function getDocumentScopeKey(
  query: DocumentScopeQuery | undefined
): string | undefined {
  const normalized = normalizeDocumentScopeQuery(query);

  if (!normalized) {
    return undefined;
  }

  return [
    normalized.inspectionId ? `inspection:${normalized.inspectionId}` : null,
    normalized.templateId ? `template:${normalized.templateId}` : null,
    normalized.issueId ? `issue:${normalized.issueId}` : null,
  ]
    .filter(Boolean)
    .join('|');
}
